import { NodeData, NodeDataByType } from './nodeData';
import { NodeType, NodeStatus } from './enums';

export type { NodeData, NodeDataByType } from './nodeData';
export type { NodeType, NodeStatus } from './enums';

export interface AppNode {
  id: string;
  type: NodeType;
  x: number;
  y: number;
  width?: number;
  height?: number;
  title: string;
  status: NodeStatus;
  parentNode?: string;
  extent?: 'parent' | [[number, number], [number, number]];
  expandParent?: boolean;
  groupId?: string;
  data: NodeData;
  inputs: string[];
}

export interface Connection {
  from: string;
  to: string;
}

export interface ContextMenuState {
  visible: boolean;
  x: number;
  y: number;
  id?: string;
}

export interface Workflow {
  id: string;
  title: string;
  thumbnail: string;
  nodes: AppNode[];
  connections: Connection[];
  groups: any[];
}

export function isGroupNode(node: AppNode): boolean {
  return node.type === NodeType.GROUP;
}

export function isGroupNodeData(data: AppNode['data']): data is import('./nodeData').GroupNodeData {
  return data.nodeType === NodeType.GROUP;
}

export function isNodeInGroup(node: AppNode): boolean {
  return node.groupId !== undefined && node.groupId !== null;
}

export function isChildOfGroup(node: AppNode, groupId: string): boolean {
  return node.groupId === groupId;
}

declare global {
  interface BongAi {
    hasSelectedApiKey: () => Promise<boolean>;
    openSelectKey: () => Promise<void>;
  }
}
